<template>
	<div>
		<GmapMap :center="center" ref="map" :zoom="15" map-type-id="terrain" :style="'width: ' + width + 'px; height: ' + height + 'px'" @click="clickMap">
			<!-- <GmapMap :center="center" ref="map" :zoom="15" map-type-id="terrain" style="width: 100%; height: 100%" @click="clickMap"> -->
			<GmapMarker :key="index" v-for="(m, index) in markers" :position="m.position" :clickable="false" :draggable="false" />
			<!-- <GmapMarker :position="position" :clickable="true" :draggable="false" @click="clickMap()" /> -->
		</GmapMap>
		<div class="view_bottom_bt" v-if="viewButton">
			<a href="javascript:;" id="save" type="button" class="search_bt" @click="select()">Select</a>
			&nbsp;<a href="javascript:;" id="save" type="button" class="gray_bt" @click="close()">Close</a>
		</div>
	</div>
</template>

<script>
import { gmapApi } from 'vue2-google-maps';

export default {
	data() {
		return {
			location: {},
			center: { lat: 40.72, lng: -73.96 },
			//placeId: null,
			//position: null,

			markers: [],
			// markers: [
			// 	{
			// 		position: {
			// 			lat: 40.72,
			// 			lng: -73.96,
			// 		},
			// 	},
			// 	{
			// 		position: {
			// 			lat: 11.0,
			// 			lng: 11.0,
			// 		},
			// 	},
			// ],

			//axiosGoogleMap: null,
		};
	},
	computed: {
		google: gmapApi,
	},
	props: {
		//initialLat: null,
		//initialLng: null,
		initialLocation: null,
		viewButton: {
			type: Boolean,
			default: true,
		},
		width: {
			type: Number,
			default: 800,
		},
		height: {
			type: Number,
			default: 550,
		},
	},
	methods: {
		clickMap(event) {
			//console.log(event);
			if (event.placeId) {
				//var clickedLocation = event.latLng;
				//console.log(clickedLocation.lat());
				//this.lat = event.latLng.lat();
				//this.lng = event.latLng.lng();
				this.location.place_id = event.placeId;
				//console.log(this.lat, this.lng, this.placeId);
			}
			// this.$dialog.confirm({
			// 	text:
			// 		"What's your name? <img src='https://upload.wikimedia.org/wikipedia/commons/thumb/f/fc/Natgeologo.svg/1200px-Natgeologo.svg.png' height=100/><input value='input'></input>",
			// 	title: 'Warning',
			// });
		},
		addMarker(position) {
			this.markers.push({ position: { lat: position.lat, lng: position.lng } });
		},
		setCenter(map) {
			var vm = this;
			var service = new this.google.maps.places.PlacesService(map);
			//var request = {};
			if (this.location.place_id) {
				//place id가 있는 경우
				//request = { placeId: this.location.place_id };
				service.getDetails({ placeId: this.location.place_id }, function(place, status) {
					//console.log(status);
					//if (status == this.google.maps.places.PlacesServiceStatus.OK) {
					if (status == 'OK') {
						//console.log(place);
						//console.log(place.geometry.location);
						vm.center.lat = place.geometry.location.lat();
						vm.center.lng = place.geometry.location.lng();
						vm.addMarker(vm.center);
						//var marker = new google.maps.Marker({
						// var marker = new this.google.maps.Marker({
						// 	map: map,
						// 	position: place.geometry.location,
						// });
						// map.setZoom(17);
						// map.setCenter(marker.getPosition());
					}
				});
			} else if (this.location.lat && this.location.lng) {
				//위도 경도가 있는 경우
				this.center.lat = this.location.lat;
				this.center.lng = this.location.lng;
				this.addMarker(this.center);
			} else {
				//그 외는 주소로 찾아본다.
				var geocoder = new this.google.maps.Geocoder();
				var address = this.location.address_detail + ',' + this.location.address_city + ',' + this.location.address_state + ',' + this.location.address_zipcode + ',' + this.location.country;
				//console.log(address);
				geocoder.geocode({ address: address }, function(results, status) {
					if (status == 'OK') {
						vm.center.lat = results[0].geometry.location.lat();
						vm.center.lng = results[0].geometry.location.lng();
						vm.addMarker(vm.center);
						// //console.log(results[0]);
						// map.setCenter(results[0].geometry.location);
						// //var marker = new google.maps.Marker({
						// marker = new google.maps.Marker({
						// 	map: map,
						// 	position: results[0].geometry.location,
						// });
						// map.setZoom(17);
						// map.setCenter(marker.getPosition());
					}
				});
			}
		},
		select() {
			if (!this.location.place_id) {
				this.$toast.error('Place not selected.');
				return;
			}
			var vm = this;
			var geocoder = new this.google.maps.Geocoder();
			geocoder.geocode({ placeId: this.location.place_id }, function(results, status) {
				//console.log(status);
				if (status == 'OK' && results[0]) {
					//console.log(results[0]);
					var street_no = '';
					var route = '';
					var city = '';
					var state = '';
					var zipcode = '';
					var country = '';

					for (var ac = 0; ac < results[0].address_components.length; ac++) {
						var component = results[0].address_components[ac];
						//console.log(component.types[0]);

						switch (component.types[0]) {
							case 'street_number':
								street_no = $.trim(component.long_name.toUpperCase());
								break;
							case 'route':
								route = $.trim(component.short_name.toUpperCase());
								break;
							case 'locality':
								city = $.trim(component.long_name.toUpperCase());
								break;
							case 'political':
								city = $.trim(component.long_name.toUpperCase());
								break;
							case 'administrative_area_level_1':
								state = $.trim(component.short_name.toUpperCase());
								break;
							case 'postal_code':
								zipcode = $.trim(component.short_name.toUpperCase());
								break;
							case 'country':
								country = $.trim(component.short_name.toUpperCase());
								break;
						}
					}
					//console.log(street_no, route, city, state, zipcode, country);
					vm.location.lat = results[0].geometry.location.lat();
					vm.location.lng = results[0].geometry.location.lng();
					vm.location.place_id = results[0].place_id;
					vm.location.address_detail = street_no + ' ' + route;
					vm.location.address_city = city;
					vm.location.address_state = state;
					vm.location.address_zipcode = zipcode;
					if (country == 'US') country = 'USA';
					vm.location.country = country;
					//console.log(vm.location);

					vm.$emit('updateLocation', vm.location);
					vm.close();
				}
			});
		},
		close() {
			//console.log('cancel');
			this.$emit('close');
		},
		// geolocate: function() {
		// 	navigator.geolocation.getCurrentPosition(position => {
		// 		this.center = {
		// 			lat: position.coords.latitude,
		// 			lng: position.coords.longitude,
		// 		};
		// 	});
		// },
	},
	created() {
		//if (this.initialLat) this.latthis.lat = 40.72;
		//if (this.initialLng) this.lng = -73.96;
		// this.lat = this.initialLat ? this.initialLat : 40.72;
		// this.lng = this.initialLng ? this.initialLng : -73.96;
		this.location = this.initialLocation ? this.initialLocation : null;
		//console.log(this.location);
		//if (this.location.placeId) {
		//console.log('place id is not null');
		//this.getInfo();
		//}
	},
	mounted() {
		this.$refs.map.$mapPromise.then(map => {
			this.setCenter(map);
			//console.log(response);
			//map.panTo({ lat: 1.38, lng: 103.8 });
			//console.log(this.google);
		});
		//this.getInfo();
		//this.geolocate();
	},
};
</script>

<style></style>
